import axios from "axios";
const service = {
  // baseURL: "http://172.16.2.43:30001/gateway", // 矫哥
  // baseURL: "https://test.api.dzplus.dzng.cc/gateway", // 测试环境
  baseURL: "https://api.dzplus.dzng.com/gateway", // api 的 base_url  正式环境
  timeout: 30000, // request timeout
  headers: { "Content-Type": "application/json;charset=UTF-8" },
};
export default function request(req) {
  if (req.url) {
    let config = Object.assign({}, service, req);
    if (!config.params) {
      config.params = {};
    }
    config.params.timestamp = new Date().getTime();
    return new Promise((resole, reject) => {
      axios
        .request(config)
        .then((res) => {
          if (res.status !== 200) {
            reject(res);
          } else {
            resole(res);
          }
        })
        .catch((err) => {
          // console.log(err)
          // console.log(err.request)
          // console.log(err.request.readyState)
          // console.log(err.request.status)
          // if(err.request.readyState == 4 && err.request.status == 0){
          //   //我在这里重新请求
          // }
          reject(err);
        });
    });
  }
}
